if (!customElements.get("nmn-header-search")) {
  customElements.define(
    "nmn-header-search",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.disclosure = this.querySelector("[data-search-disclosure]");
        this.trigger = this.querySelector("summary");
        this.input = this.querySelector("[data-search-input]");
        this.results = this.querySelector("[data-search-results]");
        this.featured = this.querySelector("[data-search-featured]");
        this.status = this.querySelector("[data-search-status]");
        this.clear = this.querySelector("[data-search-clear]");
        if (!this.disclosure || !this.input || !this.results) return;
        this.header = this.closest(".nmn-header");
        this.disclosure.addEventListener("toggle", () => {
          this.trigger.setAttribute("aria-expanded", String(this.disclosure.open));
          if (this.disclosure.open) {
            this.header?.querySelectorAll("details[open]").forEach((menu) => {
              if (menu !== this.disclosure) menu.open = false;
            });
            this.input.focus({ preventScroll: true });
            this.update();
          } else {
            this.cancel();
          }
        }, options);
        this.trigger.setAttribute("aria-expanded", String(this.disclosure.open));
        this.querySelector("form").addEventListener("submit", (event) => {
          if (!this.input.value.trim()) event.preventDefault();
        }, options);
        this.input.addEventListener("input", () => this.update(), options);
        this.clear.addEventListener("click", () => {
          this.input.value = "";
          this.update();
          this.input.focus({ preventScroll: true });
        }, options);
        this.addEventListener("keydown", (event) => {
          if (event.key === "ArrowDown" && event.target === this.input) {
            const link = (this.results.hidden ? this.featured : this.results).querySelector("a");
            if (link) {
              event.preventDefault();
              link.focus();
            }
          }
          if (event.key === "Escape" && this.disclosure.open) {
            event.preventDefault();
            event.stopPropagation();
            this.disclosure.open = false;
            this.trigger.focus();
          }
        }, options);
        this.addEventListener("focusout", (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.disclosure.open = false;
        }, options);
        document.addEventListener("click", (event) => {
          if (!this.contains(event.target)) this.disclosure.open = false;
        }, options);
        // Close search when another header menu opens, including on hover.
        this.header?.addEventListener("toggle", (event) => {
          if (event.target !== this.disclosure && event.target.open) this.disclosure.open = false;
        }, { ...options, capture: true });
      }

      cancel() {
        clearTimeout(this.timer);
        this.request?.abort();
        this.results?.removeAttribute("aria-busy");
      }

      update() {
        this.cancel();
        const term = this.input.value.trim();
        this.clear.hidden = !this.input.value;
        this.results.hidden = true;
        this.results.replaceChildren();
        this.featured.hidden = Boolean(term);
        this.status.textContent = term ? this.dataset.loading : "";
        if (!term) return;
        this.results.setAttribute("aria-busy", "true");
        this.timer = setTimeout(() => this.search(term), 200);
      }

      async search(term) {
        const request = new AbortController();
        this.request = request;
        const url = new URL(this.dataset.searchUrl, window.location.origin);
        url.searchParams.set("q", term);
        url.searchParams.set("resources[type]", "product,page,article");
        url.searchParams.set("resources[limit]", "4");
        url.searchParams.set("resources[limit_scope]", "each");
        url.searchParams.set("section_id", "header-search-results");
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error("Search unavailable");
          const document = new DOMParser().parseFromString(await response.text(), "text/html");
          const results = document.querySelector("[data-search-response]");
          if (!results) throw new Error("Missing search results");
          if (request.signal.aborted || this.input.value.trim() !== term) return;
          this.results.replaceChildren(results);
          this.results.hidden = false;
          this.featured.hidden = results.dataset.count !== "0";
          this.status.textContent = results.dataset.announcement;
        } catch (error) {
          if (request.signal.aborted) return;
          this.status.textContent = this.dataset.error;
          this.featured.hidden = false;
        } finally {
          if (this.request === request) this.results.removeAttribute("aria-busy");
        }
      }

      disconnectedCallback() {
        this.cancel();
        this.controller?.abort();
      }
    },
  );
}
